function readFirstString(...values) {
    const found = values.find(value => typeof value === 'string');

    return found !== undefined ? found : null;
}

function readServerError(body) {
    if (body && typeof body === 'object') {
        return {
            code: readFirstString(body.error, body.code),
            description: readFirstString(body.error_description, body.message),
        };
    }

    return { code: null, description: null };
}

export default readServerError;
